import React from 'react';

const NotFound = () => {
    return (  
        <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
            <p style={{margin:"0", color:"gray"}}>
                موردی یافت نشد
            </p>
        </div>
    );
}
 
export default NotFound;